export default __webpack_public_path__ + "5c0d823c3fc4c275a6333fc15399b216.png";